import { useIsMobile } from '@/hooks/use-mobile'
import { ProfileWelcomeCardMobile } from './ProfileWelcomeCardMobile'
import { ProfileWelcomeCardDesktop } from './ProfileWelcomeCardDesktop'
import { ProfileWelcomeCardBaseProps } from './ProfileWelcomeCardBase'

/**
 * Unified ProfileWelcomeCard component that renders mobile or desktop version
 * Uses useIsMobile hook to conditionally render the appropriate version
 * This approach separates mobile and desktop code completely
 */
export const ProfileWelcomeCard = (props: ProfileWelcomeCardBaseProps) => {
  const isMobile = useIsMobile()

  // Completely separate mobile and desktop rendering
  // No CSS classes mixing - pure conditional rendering
  if (isMobile) {
    return <ProfileWelcomeCardMobile {...props} />
  }

  return <ProfileWelcomeCardDesktop {...props} />
}

